import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnergyResourceService {

  constructor(private http: HttpClient) { }

  addMedicalCategory(data) : Observable<any[]> {
    if(!data.cat_id){
      return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_medical_category_action` , data);
    }
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_medical_category_action` , data);
  }

  getMedicalCategory(data) : Observable<any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null ){
        param = param.append(key , data.forms[key]);
      }
    }
    if ('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_medical_category` , {params : param});
  }
  
  editMedicalCategory(mcId): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/edit_medical_category/` + mcId);
  }

  deleteMedicalCategory(ctid): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/delete_medical_category`, {cat_id: ctid});
  }

  editMedicalCategoryStatus(stat, mapID): Observable<any> {
    const option = {
      status: stat,
      cat_id : mapID
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/energy-resources/edit_medical_category_status`, options);
  }

  selectMedicalCateory(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/select_medical_category`)
  }

  addMedicalMaster(data) : Observable<any[]> {
    if(!data.medical_id) {
      return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_medical_master_action`, data);
    }
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_medical_master_action`, data);
  }

  getMedicalMaster(data) : Observable<any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null ){
        param = param.append(key , data.forms[key]);
      }
    }
    if ('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_medical_master` , {params : param});
  }

  editMedicalMaster(mmId): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/edit_medical_master/` + mmId);
  }

  deleteMedicalMaster(mmid): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/delete_medical_master`, {medical_id: mmid});
  }
  

  // course

  addCourseCategory(data) : Observable<any[]> {
    if(!data.cat_id){
      return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_course_category_action` , data);
    }
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_course_category_action` , data);
  }

  getCourseCategory(data) : Observable<any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
        param = param.append(key, data.forms[key]);
      }
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined){
      param = param.append('page', data.pageIndex);
    }
    if('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit' , data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_course_category`, {params : param});
  }
  
  editCourseCategory(ccId): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/edit_course_category/` + ccId);
  }

  deleteCourseCategory(ctid): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/delete_course_category`, {cat_id: ctid});
  }

  editCourseCategoryStatus(params): Observable<any> {
    // const option = {
    //   status: stat,
    //   cat_id : mapID
    // };
    // const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(`${environment.apiUrl}/energy-resources/edit_course_category_status`, params);
  }

  selectCourseCateory(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/select_course_category`)
  }

  addCourseMaster(data) : Observable<any[]> {
    if(!data.course_id) {
      return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_course_master_action`, data);
    }
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_course_master_action`, data);
  }

  getCourseMaster(data) : Observable<any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null ){
        param = param.append(key , data.forms[key]);
      }
    }
    if ('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_course_master` , {params : param});
  }

  editCourseMaster(cmId): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/edit_course_master/` + cmId);
  }

  deleteCourseMaster(cmid): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/delete_course_master`, {course_id: cmid});
  }

  getErSiteMaster(data): Observable<any[]> {
    let param = new HttpParams();
    // for(const key in data.forms){
    //   if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
    //     param = param.append(key , data.forms[key]);
    //   }
    // }
    if('type' in data && data.type !== '' && data.type !== undefined ) {
      param = param.append('type' , data.type);
    }
    if('cc_ext_id' in data && data.cc_ext_id !== '' && data.cc_ext_id !== undefined ) {
      param = param.append('cc_ext_id' , data.cc_ext_id);
    }
    if('site_type' in data && data.site_type !== '' && data.site_type !== undefined ) {
      param = param.append('site_type' , data.site_type);
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined ) {
      param = param.append('page' , data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined){
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_site_master`, {params : param});
  }

  selectSiteMaster(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/select_site_master`);
  }
  getEmpERSite(cc): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_emp_erSite/` + cc);
  }

  getEmpMaster(data): Observable<any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
        param = param.append(key , data.forms[key]);
      }
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined ) {
      param = param.append('page' , data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined){
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_emp_master`, {params : param});
  }

  updateEmpCourseMaster(data) : Observable <any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
        param = param.append(key , data.forms[key]);
      }
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined ) {
      param = param.append('page' , data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined){
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/course_master_updation`, {params : param});
  }
  
  updateEmpMedicalMaster(data) : Observable <any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
        param = param.append(key , data.forms[key]);
      }
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined ) {
      param = param.append('page' , data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined){
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/medical_master_updation`, {params : param});
  }

  updateEmpPassportMaster(data) : Observable <any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
        param = param.append(key , data.forms[key]);
      }
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined ) {
      param = param.append('page' , data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined){
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/passport_master_updation`, {params : param});
  }

  updateEmpVisaMaster(data) : Observable <any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
        param = param.append(key , data.forms[key]);
      }
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined ) {
      param = param.append('page' , data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined){
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/visa_master_updation`, {params : param});
  }

  updateEmpCDCMaster(data) : Observable <any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
        param = param.append(key , data.forms[key]);
      }
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined ) {
      param = param.append('page' , data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined){
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/cdc_master_updation`, {params : param});
  }

  updateUniformShoes(data) : Observable<any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
        param = param.append(key , data.forms[key]);
      }
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined){
      param = param.append('page' , data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined){
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/employee_uniform_updation`, {params : param} );
  }

  employeeWagesDetails(data) : Observable<any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
        param = param.append(key , data.forms[key]);
      }
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined){
      param = param.append('page' , data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined){
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/employee_wages_details`, {params : param} );
  }
  getPmYojana(): Observable<any[]>{
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_pradhanmantri_yojana`);
  }
  pmYojanaMaster(data) : Observable <any[]> {
    let param = new HttpParams();
    for(const key in data.forms){
      if(data.forms !== '' && data.forms !== undefined && data.forms !== null){
        param = param.append(key , data.forms[key]);
      }
    }
    if('pageIndex' in data && data.pageIndex !== '' && data.pageIndex !== undefined ) {
      param = param.append('page' , data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined){
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/pm_yojana_updation`, {params : param});
  }

  addSiteDetails(data) : Observable<any[]> {
    if(!data.id) {
      return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_site_details`, data);
    }
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_site_details_action`, data);
  }
  
  getSiteDetails(id) : Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_site_details/` + id);
  }

  addSiteClientDetails(data) : Observable<any[]> {
    if(!data.id) {
      return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_site_client_details`, data);
    }
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_site_client_details_action`, data);
  }
  getSiteClientDetails(id) : Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_site_client_details/` + id);
  }
  deleteClientData(id) : Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/delete_client_data`, {id: id});
  }
  
  addShoesUniform(req: FormData, req_id: string): Observable<any[]> {
    if (req_id == '' || req_id == null || req_id == undefined) {
      return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_shoes_uniform_action`, req);
    }
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_shoes_uniform_action`, req);
  }
  
  getShoesUniform(data) : Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_shoes_uniform`,{params:param});
  }
  
  editshoesUniform(id) : Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/edit_shoes_uniform/` + id);
  }

  getSiteCourses(id) : Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_site_courses/` + id);
  }
  
  getSiteMedical(id) : Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_site_medical/` + id);
  }

  getSiteMedicalMap(data) : Observable <any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_site_medical_map`,{params : param});
  }

  deleteSiteMedicalMap(req): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/delete_site_medical_map`, req);
  }
  addSiteMedicalMap(req): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_site_medical_map`, req);
  }

  getSiteCourseMap(data) : Observable <any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_site_course_map`,{params : param});
  }
  deleteSiteCourseMap(req): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/delete_site_course_map`, req);
  }
  addSiteCourseMap(req): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_site_course_map`, req);
  }
  
  getEmpOngcInfo(id) : Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/employee/er-emp/get_emp_ongc_info/`+id);
  }
  
  
  addONGCPassRequest(req): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_ongc_pass_action`, req);
  }
  editONGCPassRequest(req): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_ongc_pass_details`, req);
  }

  getOngcPass(data) : Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_ongc_pass` , {params : param});
  }
  
  deleteOngcPass(req): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/delete_ongc_pass`, req);
  }

  getONGCPassTemplate(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/template_ongc_pass`);
  }
  uploadOngcPass(data): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/upload_ongc_pass`, data);
  }

  // options
  getModuleOption(grpID): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/select_er_options/` + grpID);
  }
  getUniform(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_uniforms`);
  }
  getDpndntOption(ID): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_dpndt_options/` + ID);
  }

  testAddCourse(data , mapId) : Observable<any[]> {
    if(mapId == '' || mapId == null || mapId == undefined) {
      return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/test_add_course`, data);
    }
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_test_add_course`, data);
  }

  
  addPccRequest(data , pccId): Observable<any[]> {
    if(pccId == '' || pccId == null || pccId == undefined ){
      return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_pcc_action`, data);
    }
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_pcc_action`, data);
  }

  getPccRequest(data): Observable<any>{
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_pcc_details`,{params : param});
  }

  addPccCertificate(data): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/upld_pcc_certificate`, data);
  }
  deleteEmpPcc(data): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/delete_pcc_request`, data);
  }
  editEmpPcc(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/edit_pcc_request/` + id);
  }
  
  getEmployeeRoasterPlan(data): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/get_employee_roaster_plan` , data);
  }
  getReplEmployeeRoasterPlan(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_replacement_employee_roaster_plan/` + id );
  }
  getReplEmployeeCourses(id , ccId): Observable<any[]> {
    const param = {
      user_id : id,
      cc_id : ccId,
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_replacement_employee_course` , {params : param} );
  }
  getReplEmployeeYojana(id , ccId): Observable<any[]> {
    const param = {
      user_id : id,
      cc_id : ccId,
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_replacement_employee_pmyojana` , {params : param} );
  }
  getReplEmployeeMedical(id , ccId): Observable<any[]> {
    const param = {
      user_id : id,
      cc_id : ccId,
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_replacement_employee_medical` , {params : param} );
  }
  getReplEmployeePassport(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_replacement_employee_passport/` + id );
  }
  getReplEmployeeVisa(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_replacement_employee_visa/` + id );
  }
  getReplEmployeeONGC(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_replacement_employee_ongc/` + id );
  }
  getReplEmployeePcc(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_replacement_employee_pcc/` + id );
  }
  addRoasterPlan(data): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_employee_roaster_plan`, data );
  }
  deactiveDeployeeEmployee(rst_id,rel_rst_id): Observable<any[]> {
    const param = {
      txn_id : rst_id,
      rel_txn_id : rel_rst_id,
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/deactivate_roaster_employee` , {params : param} );
  }
  addManualEmployeeToRoaster(req): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_manual_employee_roaster`, req);
  }
  removeOnboardedEmployee(req): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/remove_onboarded_employee_roaster`, req);
  }
  employeeSwitchToStandBy(req): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/employee_moveto_standby`, req);
  }
  downloadRoasterReport(ccid , type): Observable<any[]> {
    const param = {
      cc_id : ccid,
      type : type,
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/download_roaster_report`, {params: param} );
  }
  downloadManifestReport(ccid): Observable<any[]> {
    const param = {
      cc_id : ccid,
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/download_manifest_report`, {params: param} );
  }

  downloadDCCIreport(): Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/download_dcci_roaster_report`);
  }

  downloadTCCIreport(): Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/download_tcci_roaster_report`);
  }

  downloadCoursereport(): Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/download_emp_course_map_report`);
  }

  downloadMedicalreport(): Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/download_emp_medical_map_report`);
  }

  downloadGRreport(): Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/download_gr_report`);
  }

  downloadHRreport(): Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/downlaod_hr_matrics_report`);
  }

  downloadAutomationShelfMasterReport(): Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/downlaod_automation_master_report`);
  }

  empHstryReport(): Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/download_employee_roatser_history`);
  }

  getOngcReport(data):  Observable<any>{
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/download_ongc_report`,data);
  }

  getPccReport(data): Observable<any>{
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/download_pcc_report`,data);
  }

  getPassportReport(data):Observable<any>{
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/download_passport_report`,data);
  }

  getvisaReport(data):Observable<any>{
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/download_visa_report`,data);
  }

  getPMYojanaReport(data):Observable<any>{
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/download_pm_yojna_report`,data);
  }

  getCourseReport(data):Observable<any>{
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/download_course_report`,data);
  }

  getMedicalReport(data):Observable<any>{
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/download_medical_report`,data);
  }

  downloadStaffPositionReport():Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/energy-resources/download_staff_position_report`);
  }
  
  roasterEmployeeSiteDashboard(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/energy-resources/roaster_employee_dashboard`);
  }
  
  roasterSiteDashboard(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/energy-resources/roaster_site_dashboard`);
  }

  offShoreDashboard(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/energy-resources/er_offshore_dashboard`);
  }
  onShoreDashboard(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/energy-resources/er_onshore_dashboard`);
  }
  onShoreOffshoreReport(type): Observable<any>{
    const param = {
      type : type
    }
    return this.http.get<any>(`${environment.apiUrl}/energy-resources/staffposition_onshore_offshore_download`,{params : param});
  }
  campbossOffshoreOnboard(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/energy-resources/campboss_offshore_onborad_report`);
  }
  campbossOffshoreBase(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/energy-resources/campboss_offshore_base_report`);
  }
  
  //Speciality
  addSpeciality(req): Observable<any[]> {
    if (req.spl_id == '' || req.spl_id == null || req.spl_id == undefined) {
      return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/add_speciality_action`, req);
    }
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/edit_speciality_action`, req);
  }
  getSpecialityMaster(data): Observable<any>{
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/get_speciality_details`,{params : param});
  }
  deleteSpeciality(data): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/delete_speciality_request`, data);
  }
  editSpeciality(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/energy-resources/edit_speciality_request/` + id);
  }
  
  sendSMSMedicaltoEmployee(data): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/notify_employee_medical_pending`, data);

  }

  pmYojnaReport(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/energy-resources/get_report_for_pmyojna`);
  }

  getOffshoreReportDash(req): Observable<any[]>{
    return this.http.post<any[]>(`${environment.apiUrl}/energy-resources/get_report_for_dashboard`, req);
  }
  
  dwnldOngcMaster(data): Observable<any>{
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/energy-resources/get_ongc_master_report`,{params:param});
  }
  

}
